// extracted by mini-css-extract-plugin
export default {"productcard":"JB","productimage":"KB","username":"LB","multiBagName":"MB","productinfo":"NB","productinfoinner":"OB","productname":"PB","productsubheader":"QB","productdescription":"RB","productnumbers":"SB","productnumberstitle":"TB","productnumbersitem":"UB","number":"VB","numbertext":"WB","tabs":"XB","benefitsblock":"YB","benefit":"ZB","benefitname":"aC","benefitdescription":"bC","ingredientsblock":"cC","tipsblock":"eC","mobileonly":"fC"};
    if(module.hot) {
      // 1714654893238
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  